export enum GridListViewModeEnum {
  Grid = 'grid',
  List = 'list',
}
